
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 23C5.935 23 1 18.065 1 12S5.935 1 12 1s11 4.935 11 11-4.935 11-11 11z"}}),_c('path',{attrs:{"d":"M18.486 14.685a.5.5 0 00-.665.239c-1.133 2.402-3.363 3.895-5.82 3.895-2.444 0-4.675-1.493-5.821-3.896a.499.499 0 10-.902.43c1.314 2.756 3.891 4.467 6.724 4.467 2.848 0 5.425-1.712 6.725-4.469a.5.5 0 00-.239-.665zm-2.304-3.231c.853 0 1.546-.693 1.546-1.545s-.693-1.546-1.546-1.546-1.546.693-1.546 1.546.693 1.545 1.546 1.545zm0-2.091a.547.547 0 11-.001 1.093.547.547 0 01.001-1.093zm-8.363 2.091a1.547 1.547 0 000-3.091 1.546 1.546 0 000 3.091zm0-2.091a.546.546 0 11-.002 1.092.546.546 0 01.002-1.092z"}})])
          )
        }
      }
    